import { render } from "./SelectionBreadCrumb.vue?vue&type=template&id=0d2246ef"
import script from "./SelectionBreadCrumb.vue?vue&type=script&lang=js"
export * from "./SelectionBreadCrumb.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__